import {Component, Inject} from '@angular/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export type ConfirmDeleteData = { name?: string; message?: string };
@Component({
   selector: 'app-confirm-delete',
   templateUrl: 'confirm-delete.component.html',
   styleUrls: ['confirm-delete.component.css']
})
export class ConfirmDeleteComponent {
   progress: boolean;

   constructor(
      private dialogRef: MatDialogRef<ConfirmDeleteComponent>,
      @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteData
   ) {}

   /**
    *
    * @detail : deleteFile
    */
   justDelete(deleteButton: MatButton, cancelButton: MatButton) {
      deleteButton.disabled = true;
      cancelButton.disabled = true;
      this.progress = true;
      this.dialogRef.close(true);
   }
}
